import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { InventoryClosingFormComponent } from "../inventory-closing-form/inventory-closing-form.component";

@Component({
  selector: "ngx-inventory-closing-list",
  templateUrl: "./inventory-closing-list.component.html",
  styleUrls: ["./inventory-closing-list.component.scss"],
})
export class InventoryClosingListComponent extends BaseListComponent {
  columns: form_control[] = [];
  constructor() {
    super();
    this.inputEditorform = InventoryClosingFormComponent;
  }
  ngOnInit() {
    this.apiName = "InventoryClosing";
    this.areaName = "Inventory";
    this.label = "انتقال موجودی اول دوره";
    this.setColumns();
  }
  setColumns() {
    this.columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "WarehouseTitle",
        modelName: "WarehouseTitle",
        listVisible: true,
        label: "انبار",
        order: 11,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "VoucherKindTitle",
        modelName: "VoucherKindTitle",
        listVisible: true,
        label: "نوع سند",
        order: 12,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "VoucherNo",
        modelName: "VoucherNo",
        listVisible: true,
        label: "شماره سند",
        order: 13,
        textType: "number",
        withComma: false,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "ShamsiVoucherDate",
        modelName: "ShamsiVoucherDate",
        listVisible: true,
        label: "تاریخ سند",
        order: 14,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "VoucherDate",
        modelName: "VoucherDate",
        listVisible: false,
        label: "تاریخ سند",
        order: 15,
        textType: "date",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "StatusKindTitle",
        modelName: "StatusKindTitle",
        listVisible: true,
        label: "وضعیت سند",
        order: 16,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "TotalPrice",
        modelName: "TotalPrice",
        listVisible: true,
        label: "جمع خالص",
        order: 17,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "AccVoucherHeaderId",
        modelName: "AccVoucherHeaderId",
        listVisible: false,
        label: "ارجاع به سند حسابداری",
        order: 18,
        textType: "number",
        withComma: false,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "AccVoucherNo",
        modelName: "AccVoucherNo",
        listVisible: true,
        label: "ُسند حسابدازی",
        order: 19,
        textType: "number",
        withComma: false,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
  }
}
